import { gql } from "graphql-request";

const SERVER_DELETE_ANNOUNCEMENTS = gql`
  mutation SERVER_DeleteAnnouncement($id: ID!) {
  deleteAnnouncement(id: $id)
}
`;
export default SERVER_DELETE_ANNOUNCEMENTS;
